import AntdAvatar from 'components/Avatar'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import { InfoSection } from 'components/TableStyles/TableContentStyles/TableContentStyles'
import { getRoleRoundInterviewerLists } from 'modules/InterviewerDashboard/actions'
import PreviewContent from 'modules/Roles/NewRoleCreation/Partials/PreviewRoleDrawer/PreviewContent'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import {
  BoldText,
  LightText1,
  LightText2,
  StyledCol,
  StyledRow,
  TitleText,
} from './style'

const PreviewRoleDrawer = ({
  previewDrawer,
  setPreviewDrawer,
  previewRoleData,
  currentTimeDetails,
  currentSelection,
}) => {
  const dispatch = new useDispatch()

  const [interviewerList, setInterviewerList] = useState([])

  useEffect(() => {
    ;(async () => {
      let responce = await dispatch(
        getRoleRoundInterviewerLists(
          currentSelection?.roleId,
          currentSelection?.interviewRound,
          currentTimeDetails?.startDateWithTimestamp
        )
      )
      setInterviewerList(responce)
    })()
    return () => {}
  }, [currentTimeDetails])
  const onCloseDrawer = () => {
    setPreviewDrawer(false)
  }

  const content = () => {
    return (
      <>
        <StyledRow>
          <StyledCol span={22}>
            <TitleText>Interview Discussion Details</TitleText>
            <LightText2>
              {' '}
              {currentTimeDetails?.mode === 'EXTERNAL_LINK'
                ? 'Online'
                : 'Offline'}{' '}
              | {moment(currentTimeDetails?.startDate).format('Do MMM, YYYY')} |{' '}
              {currentTimeDetails?.startAMPMTime +
                '-' +
                currentTimeDetails?.endAMPMTime}
            </LightText2>
          </StyledCol>
          <StyledCol span={22}>
            <TitleText>Interviewers</TitleText>
            {interviewerList?.map((item, index) => (
              <Flex
                alignVertically
                style={{ margin: '12px' }}
                key={index + 'interViewerList'}
              >
                <AntdAvatar
                  src={null}
                  IconName={item?.interviewerDetails?.first_name?.[0]}
                  size={35}
                />
                <InfoSection>
                  <BoldText>
                    {item?.interviewerDetails?.first_name}{' '}
                    {item?.interviewerDetails?.last_name}
                  </BoldText>
                  <LightText1>
                    {item?.interviewerDetails?.email} |{' '}
                    {item?.interviewerDetails?.phone_number}
                  </LightText1>
                </InfoSection>
              </Flex>
            ))}
          </StyledCol>
        </StyledRow>
        <PreviewContent previewRoleData={previewRoleData} />
      </>
    )
  }

  return (
    <Drawer
      zIndex="1001"
      width="80%"
      title={'Job Details'}
      placement="right"
      visible={previewDrawer}
      padding="0 0 20px 0"
      content={content()}
      closable={true}
      onClose={onCloseDrawer}
    />
  )
}

export default PreviewRoleDrawer
